/*
 * Returns true if the company is removed from the portfolio. Should only be used with objects
 * that are returned from the `usePortfolioCompanyAggregates` hook.
 */
export default (company) => company?.removed;
